import init from 'src/lib/init.js'
import { initSelectAll } from "src/lib/select-all.js"

init()
initSelectAll()



